/**
 * Small, focused formatting helpers for currency, percentages, and date-times.
 */

export const formatCurrencyUSD = (value) => {
  const n = Number.isFinite(value) ? value : 0;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    // Fallback if Intl not available
    return `$${(Math.round(n * 100) / 100).toFixed(2)}`;
  }
};

export const formatCurrencyCompact = (value) => {
  const n = Number.isFinite(value) ? value : 0;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return formatCurrencyUSD(n);
  }
};

export const formatPercent = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const n = Number(value);
  return `${(n * 100).toFixed(1)}%`;
};

// Decimal precision by unit: discrete/small units show as whole numbers,
// volume-ish continuous units get 1 decimal, everything else (weight like KG,
// or an unrecognized unit) gets 2 — generalizes the per-unit rule that used
// to live only inside InventoryItem.js so every inventory quantity display
// (ingredients, finished goods) follows the same one rule.
const ZERO_DECIMAL_UNITS = new Set(['MG', 'ML', 'S', 'UNITS', 'CANS', 'KEGS', 'BOTTLES']);
const ONE_DECIMAL_UNITS = new Set(['GRAMS', 'LITERS', 'GALLONS']);

export const formatQuantity = (value, unit) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const u = (unit || '').toString().toUpperCase();
  if (ZERO_DECIMAL_UNITS.has(u)) return String(Math.round(n));
  if (ONE_DECIMAL_UNITS.has(u)) return n.toFixed(1);
  return n.toFixed(2);
};

export const formatDateTimeLocal = (input) => {
  if (!input) return '—';
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '—';
  try {
    return date.toLocaleString();
  } catch {
    return date.toISOString();
  }
};